var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { Component } from 'react';
import { Icon } from "../../UI";
import { t, Translate } from "../../I18N";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";
import { exportDocuments } from "../actions/exportActions";

import Modal from "../../Layout/Modal";

import { Captcha, FormGroup } from "../../ReactReduxForms";

import { LocalForm } from "../../Forms/Form";










class ExportButton extends Component {


  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
    this.export = this.export.bind(this);
    this.showModal = this.showModal.bind(this);
    this.exportWithCaptcha = this.exportWithCaptcha.bind(this);
  }

  export() {
    if (!this.props.processing) {
      this.props.exportDocuments(this.props.storeKey);
    }
  }

  exportWithCaptcha(values) {
    if (!this.props.processing) {
      this.props.exportDocuments(this.props.storeKey, values.captcha);
    }
    this.setState({ modal: false });
  }

  showModal() {
    this.setState({ modal: true });
  }

  render() {
    let btnClassName = 'btn btn-default btn-export';
    btnClassName += this.props.processing ? ' btn-disabled' : '';
    btnClassName += ` ${this.props.className}`;
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.user.get('_id') ? this.export : this.showModal,
        className: btnClassName }, void 0,

      !this.props.processing ? /*#__PURE__*/
      _jsx(Icon, { icon: "export-csv", transform: "up-0.1" }) : /*#__PURE__*/

      _jsx(Icon, { icon: "spinner", spin: true }), /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Export CSV'))
      ),
      this.state.modal && /*#__PURE__*/
      _jsx(Modal, { isOpen: true, type: "export" }, void 0, /*#__PURE__*/
      _jsx(LocalForm, {
        onSubmit: this.exportWithCaptcha,
        validators: { captcha: { required: (val) => val && val.text.length } } }, void 0, /*#__PURE__*/

      _jsx(FormGroup, { model: ".captcha" }, "captcha", /*#__PURE__*/
      _jsx("h3", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Exporting entities to CSV")
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Please type in letters and numbers from the image to start the export."

      )
      ), /*#__PURE__*/
      _jsx(Captcha, { remote: false, model: ".captcha" })
      ), /*#__PURE__*/
      _jsx("div", { className: "buttons" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "button",
        className: "btn",
        onClick: () => {
          this.setState({ modal: false });
        },
        value: "Cancel" }
      ), /*#__PURE__*/
      _jsx("input", { type: "submit", className: "btn btn-success", value: "Export" })
      )
      )
      )

      ));

  }
}_defineProperty(ExportButton, "defaultProps", void 0);

ExportButton.defaultProps = {
  className: ''
};

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({ exportDocuments }, wrapDispatch(dispatch, props.storeKey));
}

function mapStateToProps(state) {
  return {
    processing: state.exportSearchResults.exportSearchResultsProcessing,
    user: state.user
  };
}



export default connect(mapStateToProps, mapDispatchToProps)(ExportButton);